// src/redux/slices/projectAssignedAction.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config/api";
import axiosInstance from "../../../config/axiosConfig";

const BackendUrl = config.backendUrl;

export const projectAssignedAction = createAsyncThunk(
  "projectAssigned/action",
  async ({ projectid
   }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendUrl}/project-assigned/salesperson`,
        {
          projectid
        }
      );
      return response.data; // backend response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const projectRejectAssignedAction = createAsyncThunk(
  "projectRejectAssigned/action",
  async ({ projectid
   }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendUrl}/project-assigned/salesperson-reject`,
        {
          projectid
        }
      );
      return response.data; // backend response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);


export const projectReviewOpAction = createAsyncThunk(
  "projectReviewOpAction/action",
  async ({ payload
   }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendUrl}/project-assigned/operation-review`,
payload
      );
      return response.data; // backend response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);
export const projectReviewManagerAction = createAsyncThunk(
  "projectReviewManagerAction/action",
  async ({ payload
   }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendUrl}/project-assigned/manager-review`,
payload
      );
      return response.data; // backend response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// 🔹 Slice
const projectAssignedActionSlice = createSlice({
  name: "projectAssignedAction",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetProjectAssignedAction: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(projectAssignedAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(projectAssignedAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(projectAssignedAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

           .addCase(projectRejectAssignedAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(projectRejectAssignedAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(projectRejectAssignedAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
                .addCase(projectReviewOpAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(projectReviewOpAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(projectReviewOpAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
        .addCase(projectReviewManagerAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(projectReviewManagerAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(projectReviewManagerAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetProjectAssignedAction } =
  projectAssignedActionSlice.actions;

export default projectAssignedActionSlice.reducer;
